import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { useState, useEffect } from 'react';

interface SessionState {
  // 在這裡加入你需要的資料欄位
  // 範例：
  // someValue: string | null;
  source?: string;
}

interface SessionActions {
  // 對應的 setter
  // 範例：
  // setSomeValue: (value: string | null) => void;
  setSource: (source: string) => void;
  clearSession: () => void;
}

type SessionStore = SessionState & SessionActions;

const initialState: SessionState = {
  // someValue: null,
};

export const useSessionStore = create<SessionStore>()(
  persist(
    (set) => ({
      ...initialState,

      // setSomeValue: (value) => set({ someValue: value }),
      setSource: (source: string) =>
        set((state) => ({
          ...state,
          source,
        })),

      clearSession: () => set(initialState),
    }),
    {
      name: 'ugo-session', // name of the item in the storage (must be unique)
      storage: createJSONStorage(() => sessionStorage), // (optional) by default, 'localStorage' is used
    },
  ),
);

// 避免 hydration error
export function useMountedSessionStore<T>(
  selector: (state: SessionStore) => T,
  serverFallback?: T,
): T | undefined {
  const [mounted, setMounted] = useState<boolean>(false);
  const value = useSessionStore<T>(selector);

  useEffect(() => {
    setMounted(true);
  }, []);

  return mounted ? value : serverFallback;
}
